import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';

import { FilterGroup } from '@finder/features/list/components/filters/classes/filter-group.class';
import { ListDrawerComponent } from '@finder/features/list/components/filters/components/list-drawer/list-drawer.component';
import { CommonModule } from '@angular/common';
import { AllFiltersComponent } from '../all-filters/all-filters.component';

@Component({
    selector: 'finder-filter-drawer',
    templateUrl: './filter-drawer.component.html',
    styleUrls: ['./filter-drawer.component.scss'],
    standalone: true,
    imports: [
        ListDrawerComponent,
        CommonModule,
        AllFiltersComponent,
    ]
})
export class FilterDrawerComponent implements OnDestroy {

    @Input() displayed = false;
    @Input() shrinkButtons = false;
    @Input() sourceElement: HTMLElement;
    @Input() filters: FilterGroup[];
    @Input() labels: any;
    @Input() useHeightFilter = false;

    @ViewChild(ListDrawerComponent, { static: false }) listDrawer: ListDrawerComponent;

    displayedStateChanged$ = new Subject<boolean>();

    constructor() { }

    ngOnDestroy() {
        this.displayedStateChanged$.complete();
    }

    changed(value) {
        this.displayedStateChanged$.next(value);
    }
}
